<template>
    <div v-if="order">
        <div class="offer-header">
            <div class="page-title">
                <h4> Vizualizare comanda {{order.id}} din data: {{ order.created_at | moment("DD.MM.YYYY")}} </h4>
                <p> Status: {{ this.status }} </p>
            </div>
        </div>
        <div class="order-author">
            <span>
                <i class="fas fa-info-circle"></i>
                Comanda efectuata de: {{ ((order.partner) ? (order.partner.first_name) ? order.partner.first_name : (order.partner.last_name) ? order.partner.last_name : '-': ((order.employee) ? (order.employee.first_name) ? order.employee.first_name  : (order.employee.last_name) : '-'))}}
            </span>
        </div>
        <div class="row justify-content-center">
          <div class="col-xl-4 col-lg-4 col-12" v-if="order.partner">
            <ul class="template-offer-details">
              <h4> {{$t('placeholder.datePartener')}} </h4>
              <li  v-if="order.partner && order.partner.type === 2"> <span> {{$t('placeholder.numeCompanie')}}: </span> <p>{{order.partner.company_name ? order.partner.company_name : '-'}} </p> </li>
              <li v-if="order.partner  && order.partner.type === 2"> <span > {{$t('placeholder.cui')}}: </span> <p>{{order.partner.cui ? order.partner.cui : '-'}} </p> </li>
              <li v-if="order.partner  && order.partner.type === 2"> <span > {{$t('placeholder.nrRegCom')}}: </span> <p>{{order.partner.nr_reg ? order.partner.nr_reg: '-' }} </p> </li>
              <li> <span> {{$t('placeholder.nume')}}: </span> <p>{{order.partner.last_name}} {{order.partner.first_name}} </p> </li>
              <li> <span> {{$t('placeholder.email')}}: </span> <p>{{order.partner.email}} </p> </li>
              <li> <span> {{$t('placeholder.telefon')}}: </span> <p>{{order.partner.phone}} </p> </li>
            </ul>
          </div>
          <div class="col-xl-4 col-lg-4 col-12" v-if="order.employee && $hasRole(['employee' ,'admin'])">
            <ul class="template-offer-details">
              <h4> {{$t('placeholder.dateFurnizor')}} </h4>
              <li v-if="settings.company_name"> <span > {{$t('placeholder.numeCompanie')}}: </span> <p>{{settings.company_name}} </p> </li>
              <li v-if="settings.cui"> <span > {{$t('placeholder.cui')}}: </span> <p>{{settings.cui}} </p> </li>
              <li v-if="settings.nr_reg_com"> <span > {{$t('placeholder.nrRegCom')}}: </span> <p>{{settings.nr_reg_com}} </p> </li>
              <li v-if="settings.phone"> <span> {{$t('placeholder.telefon')}}: </span> <p>{{ settings.phone }} </p> </li>
              <li v-if="settings.county"> <span> {{$t('placeholder.judet')}}: </span> <p>{{ settings.county.name }}  </p> </li>
              <li v-if="settings.city"> <span> {{$t('placeholder.oras')}}: </span> <p>{{ settings.city.name }}  </p> </li>
              <li v-if="settings.address"> <span> {{$t('placeholder.adresa')}}: </span> <p>{{ settings.address }}  </p> </li>
              <li v-if="settings.bank"> <span> {{$t('placeholder.banca')}}: </span> <p>{{ settings.bank }}  </p> </li>
              <li v-if="settings.iban"> <span> {{$t('placeholder.iban')}}: </span> <p>{{ settings.iban }}  </p> </li>
            </ul>
          </div>
          <div class="col-xl-4 col-lg-4 col-12" v-if="order.client">
            <ul class="template-offer-details">
              <h4> {{$t('txt.cumparator')}} </h4>
              <li> <span> {{$t('placeholder.nume')}}: </span> <p>{{ (order.billing_info.billing_client_type == 2) ?  order.billing_info.billing_company : order.billing_info.billing_first_name+' '+order.billing_info.billing_last_name}} </p> </li>
              <li v-if="order.billing_info.billing_client_type == 2"> <span > {{$t('placeholder.cui')}}: </span> <p>{{order.billing_info.billing_cui}} </p> </li>
              <li v-if="order.billing_info.billing_client_type == 2"> <span > {{$t('placeholder.nrRegCom')}}: </span> <p>{{order.billing_info.billing_nr_reg}} </p> </li>
              <li v-if="order.billing_info.billing_county"> <span> {{$t('placeholder.judet')}}: </span> <p>{{order.billing_info.billing_county.name}} </p> </li>
              <li v-if="order.billing_info.billing_city"> <span> {{$t('placeholder.oras')}}: </span> <p>{{ order.billing_info.billing_city.name}} </p> </li>
              <li v-if="order.billing_info.billing_address"> <span> {{$t('placeholder.adresa')}}: </span> <p>{{ order.billing_info.billing_address}} </p> </li>
              <li v-if="order.billing_info.billing_phone"> <span> {{$t('placeholder.telefon')}}: </span> <p>{{order.billing_info.billing_phone}} </p> </li>
            </ul>
          </div>
        </div>
          <div class="preview-offer-client">
            <h4> {{$t('txt.compozitieComanda')}} </h4>
        </div>
        <div class="composition-template offer-composition-template">
            <div class="order-header">
                <div class="order-legend">
                    <p class="checked-in-product"> Produse facturate </p>
                    <p class="demanded-product"> Produse comandate </p>
                </div>
            </div>
            <div class="offer-table-wrapper">
                <table>
                    <thead>
                    <tr>
                        <th>
                            <span>
                                {{$t('tableHeader.nrCrt')}}
                            </span>
                        </th>
                        <th>
                            <p class="final-table-header">
                                {{$t('placeholder.denumire')}}
                            </p>
                        </th>
                        <th class="tablehead-price">
                            <div class="type-price">
                                <p> {{$t('placeholder.tipPret')}} </p>
                            </div>
                        </th>
                        <th>
                            <p class="final-table-header">
                                {{$t('placeholder.cantitate')}}
                            </p>
                        </th>
                        <th>
                            <p class="final-table-header">
                                {{$t('txt.subtotal')}}
                            </p>
                        </th>
                        <th>
                            <p class="final-table-header">
                                {{$t('tableHeader.adaos')}}
                            </p>
                        </th>
                        <th>
                            <p class="final-table-header">
                                {{$t('tableHeader.discount')}}
                            </p>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(order_row, index) in order_rows.products" :key="`row-order-product-${order_row.id}-${index}`">
                        <td>
                            <p> {{index + 1}} </p>
                        </td>
                        <td :tableheadData="$t('placeholder.denumire')" class="order-prdname-wrapper">
                              <div class="final-order-name">
                                  <p> {{order_row.name}} </p>
                              </div>
                        </td>
                        <td :tableheadData="$t('placeholder.pret')">
                            <div class="type-price">
                                <p> {{order_row.price | formatPrice}} | {{order_row.price_category_name}} </p>
                            </div>
                        </td>
                        <td :tableheadData="$t('placeholder.cantitate')" class="order-qty-wrapper">
                            <div class="view-template-qty" v-for="(warehouse, indexw) in order_row.warehouses" :key="`order-row-warehouse-${order_row.id}-${warehouse.id}-${indexw}`">
                                <div class="view-qty-ammount">
                                  <p> {{order_row.qty}} </p>
                                  <i class="fas fa-times"></i>
                                  <p class="qty-location"> {{warehouse.key}} </p>
                                </div>
                                <div class="view-qty-status">
                                  <span class="billed-qty"> {{warehouse.qtyBilled}} </span>
                                  <span class="orginal-qty"> {{warehouse.initialQty}} </span>
                                </div>
                            </div>
                        </td>
                        <td :tableheadData="$t('txt.subtotal')">
                            <div class="final-offer-price">
                                <p> {{order_row.subtotal | formatPrice }} </p>
                            </div>
                        </td>
                        <td :tableheadData="$t('tableHeader.adaos')">
                            <div class="view-price-modifier">
                                {{ order_row.addition | formatPrice }} &nbsp
                                <i class="fas fa-percentage"></i>
                            </div>
                        </td>
                        <td :tableheadData="$t('tableHeader.discount')">
                            <div class="view-price-modifier">
                                {{order_row.discount | formatPrice }} &nbsp
                                <i class="fas fa-percentage"></i>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(order_row, index) in order_rows.services" :key="`row-order-service-${order_row.id}-${index}`">
                        <td :tableheadData="$t('placeholder.denumire')">
                            <div class="final-offer-name final-order-name">
                                <p> {{order_row.name}} </p>
                            </div>
                        </td>
                        <td :tableheadData="$t('placeholder.pret')">
                            <div class="type-price">
                                <p> {{order_row.price | formatPrice}} </p>
                            </div>
                        </td>
                        <td :tableheadData="$t('placeholder.cantitate')">
                            <div class="view-template-qty">
                                <p> {{order_row.qty}} </p>
                            </div>
                        </td>
                        <td :tableheadData="$t('txt.subtotal')">
                            <div class="final-offer-price">
                                <p> {{subtotalRow(index, 'services') | formatPrice}} </p>
                                <!--<p> RON </p>-->
                            </div>
                        </td>
                        <td :tableheadData="$t('tableHeader.adaos')">
                            <div class="view-price-modifier">
                                <p> {{order_row.addition || ''}} </p>
                                <i class="fas fa-percentage" v-if="order_row.addition"></i>
                            </div>
                        </td>
                        <td :tableheadData="$t('tableHeader.discount')">
                            <div class="view-price-modifier">
                                <p> {{order_row.discount || ''}} </p>
                                <i class="fas fa-percentage" v-if="order_row.discount"></i>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(order_row, index) in order_rows.post_services" :key="`row-order-service-ps-${order_row.id}-${index}`">
                        <td :tableheadData="$t('placeholder.denumire')">
                            <div class="final-offer-name final-order-name">
                                <p> {{order_row.name}} </p>
                            </div>
                        </td>
                        <td :tableheadData="$t('placeholder.pret')">
                            <div class="type-price">
                                <p> {{order_row.price | formatPrice}} </p>
                                <!-- <div class="type-price">
                                    <b-form-select v-model="selected" :options="options"></b-form-select>
                                </div> -->
                            </div>
                        </td>
                        <td :tableheadData="$t('placeholder.cantitate')">
                            <div class="view-template-qty">
                                <p> {{order_row.qty}} </p>
                            </div>
                        </td>
                        <td :tableheadData="$t('txt.subtotal')">
                            <div class="final-offer-price">
                                <p> {{subtotalRow(index, 'post_services') | formatPrice}} </p>
                                <!--<p> RON </p>-->
                            </div>
                        </td>
                        <td :tableheadData="$t('tableHeader.adaos')">
                            <div class="view-price-modifier">
                                <p> {{order_row.addition || ''}} </p>
                                <i class="fas fa-percentage" v-if="order_row.addition"></i>
                            </div>
                        </td>
                        <td :tableheadData="$t('tableHeader.discount')">
                            <div class="view-price-modifier">
                                <p> {{order_row.discount || ''}} </p>
                                <i class="fas fa-percentage" v-if="order_row.discount"></i>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="composition-info">
            <ul>
                <li>
                    <h5> {{$t('txt.puncteRecompensa')}}  </h5>
                    <p> {{(this.order.pts_rewards_employee) ? this.order.pts_rewards_employee : ((this.order.pts_rewards_partner) ? this.order.pts_rewards_partner : Math.round(this.order.total/ this.order.settings_amount))}} </p>
                </li>
                <li>
                    <h5> {{$t('txt.subtotal')}}  </h5>
                    <p> {{order.subtotal | formatPrice}} </p>
                </li>
                <li>
                    <h5> {{$t('tableHeader.discount')}}  </h5>
                    <span class="discount-label"> <i class="fas fa-percentage"></i> </span>
                    <span class="discount-view"> {{order.discount}} </span>
                </li>
                <li>
                    <h5> {{$t('txt.total')}}  </h5>
                    <p> {{order.total | formatPrice}}</p>
                </li>
                <!-- <li class="button-wrapper">
                  <div class="generate-button">
                      <router-link :to="{ name: 'createInvoiceFromOrder', params: { id: order.id }}" class="view-user"
                                   data-placement="top" data-toggle="tooltip">
                          <i class="far fa-save"></i>
                          {{$t('txt.emiteFactura')}}
                      </router-link>
                  </div>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
import OrdersService from '../../api-services/orders.service.js'
import SettingsService from '../../api-services/settings.service.js'
import ProductsService from '../../api-services/products.service.js'
export default {
  name: 'viewOrder',
  data () {
    return {
      warehouses: null,
      order: null,
      settings: null,
      priceCategoryes: null,
      globalPriceRange: {
        key: 0,
        name: 'Categorie de pret'
      },
      order_rows: {
        products: [],
        services: [],
        post_services: []
      }
    }
  },
  computed: {
    status () {
      let status = ''
      switch (parseInt(this.order.status)) {
        case 1: status = 'Comanda noua'
          break
        case 2: status = 'Pregatita de livrare'
          break
        case 3: status = 'Finalizata'
          break
        case 4: status = 'Anulata'
          break
      }
      return status
    }
  },
  methods: {
    subtotalRow (index, collection) {
      let subtotal = this.order_rows[collection][index].price * this.order_rows[collection][index].qty
      let addition = 0
      let discount = 0
      if (this.order_rows[collection][index].addition && this.order_rows[collection][index].addition !== 0) {
        addition = Math.abs(this.order_rows[collection][index].addition) / 100 * subtotal
      }
      if (this.order_rows[collection][index].discount && this.order_rows[collection][index].discount !== 0) {
        discount = Math.abs(this.order_rows[collection][index].discount) / 100 * subtotal
      }
      return subtotal + addition - discount
    },
    getWarehouses () {
      return new Promise((resolve, reject) => {
        ProductsService.getWarehouses()
          .then((response) => {
            this.warehouses = response.data.data.data
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getQtyOrder (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return element.id === warehouseId
        })
        if (stock) {
          return stock.disponibleStock
        }
      }
      return 0
    },
    getQtyReservedOrder (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return element.id === warehouseId
        })
        if (stock) {
          return stock.reserved
        }
      }
      return 0
    },
    checkIsInInvoice (productId, collection) {
      if (this.invoice_rows[collection].find(product => product.id === parseInt(productId))) return true
      return false
    },
    getOrder () {
      return new Promise((resolve, reject) => {
        OrdersService.get(this.$route.params.id)
          .then((response) => {
            this.order = response.data.data
            let products = response.data.data.products
            let services = response.data.data.services
            let servicesPs = response.data.data.post_services
            let priceCategory = 0
            let vm = this
            products.forEach(function (product) {
              let dataQty = []
              let totalQty = 0
              product.warehouses.forEach(function (warehouse) {
                priceCategory = warehouse.price_category
                dataQty.push({
                  id: warehouse.id,
                  name: warehouse.name,
                  key: warehouse.key,
                  qty: warehouse.qty - warehouse.qtyBilled,
                  disponibleStock: warehouse.disponibleStock,
                  reserved: warehouse.reserved,
                  qtyBilled: warehouse.qtyBilled,
                  initialQty: warehouse.qty
                })
                totalQty = parseInt(totalQty) + parseInt(warehouse.qty)
              })
              let priceCat = vm.priceCategoryes.find(price => parseInt(price.value) === parseInt(priceCategory))
              let priceCatName = priceCat.display

              let obj = {
                id: product.id,
                warehouses: dataQty,
                price_category: priceCategory,
                price_category_name: priceCatName,
                price: product.price,
                subtotal: product.subtotal,
                price_min: product.price_min,
                price_distribution: product.price_distribution,
                price_partner: product.price_partner,
                price_retail: product.price_retail,
                name: product.name,
                qty: totalQty,
                addition: (parseInt(product.price) - parseInt(product.prices.pp_minim)) / parseInt(product.prices.pp_minim) * 100,
                discount: -(parseInt(product.price) - parseInt(product.prices.pp_amanunt)) / parseInt(product.prices.pp_amanunt) * 100
              }
              vm.order_rows.products.push(obj)
            })
            services.forEach(function (service) {
              let obj = {
                id: service.id,
                price: service.price,
                name: service.name,
                qty: service.qty,
                addition: service.addition || null,
                discount: service.discount || null
              }
              vm.order_rows.services.push(obj)
            })
            servicesPs.forEach(function (service) {
              let obj = {
                id: service.id,
                price: service.price,
                name: service.name,
                qty: service.qty,
                addition: service.addition || null,
                discount: service.discount || null
              }
              vm.order_rows.post_services.push(obj)
            })
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getSettings () {
      return new Promise((resolve, reject) => {
        SettingsService.get()
          .then((response) => {
            this.settings = response.data.data
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    }
  },
  async created () {
    this.priceCategoryes = ProductsService.getPriceCategories()
    await this.getSettings()
    await this.getWarehouses()
    await this.getOrder()
    this.$store.dispatch('hideLoading')
  }
}
</script>
